import { CgClose } from "react-icons/cg";


function ModalTitleButton({ text, closeModal, chooseAction, children }) {
    return (
        <>
            <div className="flex flex-row-reverse items-center justify-between
                         bg-purpleDark rounded-t-lg text-white py-3 px-4 shadow">
                <p className="mr-2">{text}</p>
                <CgClose
                    size={21}
                    onClick={() => closeModal(false)}
                />
            </div>

            {children}

            <div className="flex flex-row-reverse justify-around mt-5">
                <button
                    onClick={chooseAction}
                    className="bg-purpleDark text-white font-bold rounded-lg w-56 py-2 shadow"
                >{text}</button>
                <button
                    onClick={() => closeModal(false)}
                    className="w-56 py-2 bg-white font-bold t-purpleDark shadow border-2 border-blue-500 rounded-lg"
                >لغو</button>
            </div>
        </>
    )
}
export default ModalTitleButton;